import React from "react";
import { Link } from "../../utils/customLink";
import ArrowRight from "../../images/icons/arrow-right.inline.svg";
import ArrowRightBigIcon from "../../images/icons/arrow-right-big-icon.inline.svg";

export const VISubjectSlide = ({ index, slideData, subjectsCount }) => {
  const { title, description, pageLink } = slideData;
  return (
    <div
      className="flex flex-col px-4 md:px-24 pt-7 pb-20 md:py-12 md:border-0.5 md:border-gray-testimonial rounded-xs h-full dark:bg-[#090909]/80 dark:border-0
    before:absolute before:w-full before:h-full md:before:gvi-blur-bg dark:before:backdrop-blur-none before:top-0 before:right-0 before:-z-10"
    >
      <h3 className="hidden md:block pb-7 text-white font-semibold dark:font-light font-body">
        {subjectsCount} subject areas to choose from
      </h3>
      <div className="flex items-center gap-6 pb-7">
        <div className="flex w-16 h-16 rounded-full border border-black-lighter md:border-white dark:border-white dark:border-2">
          <h2 className="m-auto text-black-lighter md:text-white font-bold text-[26px] md:text-xlrg-sm">
            {index + 1}
          </h2>
        </div>
        <h1
          className="text-black-lighter md:text-white font-normal dark:font-semibold font-alice dark:font-body leading-[43px]"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div
        className="text-mob md:text-base pb-10 text-black-lighter md:text-white dark:text-gray-generic"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="mt-auto">
        <Link
          className="callback-button group inline-flex justify-center items-center px-16 py-2 w-full md:w-auto bg-white hover:bg-black-lighter hover:text-white dark:bg-transparent dark:hover:bg-white dark:hover:text-gray-darker"
          to={pageLink}
        >
          <p className="pr-2">Read more</p>
          <ArrowRightBigIcon className="dark:hidden fill-black-lighter group-hover:fill-white" />
          <ArrowRight className="hidden dark:block w-3 h-3 stroke-white group-hover:stroke-gray-darker" />
        </Link>
      </div>
    </div>
  );
};
